import { render, staticRenderFns } from "./IndexCourseResourceCard1.vue?vue&type=template&id=236ea136&scoped=true"
import script from "./IndexCourseResourceCard1.vue?vue&type=script&lang=js"
export * from "./IndexCourseResourceCard1.vue?vue&type=script&lang=js"
import style0 from "./IndexCourseResourceCard1.vue?vue&type=style&index=0&id=236ea136&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236ea136",
  null
  
)

export default component.exports